/**
 * L'elenco dei dispositivi mentre si compila, per il web e per l'app: i numeri
 * restano testo finché non si salva. Nessuna dipendenza di piattaforma.
 */

import type { ApplianceType, MemberAppliance } from '@slims/shared/energy';

/** Una riga dell'elenco. */
export interface ApplianceDraft {
	tipo: ApplianceType | '';
	nome: string;
	quantita: string;
	potenzaKw: string;
}

export const EMPTY_APPLIANCE_DRAFT: ApplianceDraft = {
	tipo: '',
	nome: '',
	quantita: '1',
	potenzaKw: '',
};

export function appliancesToDraft(items: MemberAppliance[] | null | undefined): ApplianceDraft[] {
	return (items ?? []).map((a) => ({
		tipo: a.tipo,
		nome: a.nome ?? '',
		quantita: String(a.quantita),
		potenzaKw: a.potenzaKw == null ? '' : String(a.potenzaKw).replace('.', ','),
	}));
}

/**
 * Le righe pronte per l'API. Le righe senza tipo si scartano: sono quelle
 * aggiunte e lasciate vuote. Il controllo dei valori lo fa l'API.
 */
export function draftToAppliances(rows: ApplianceDraft[]): MemberAppliance[] {
	return rows
		.filter((r): r is ApplianceDraft & { tipo: ApplianceType } => r.tipo !== '')
		.map((r) => ({
			tipo: r.tipo,
			...(r.tipo === 'altro' ? { nome: r.nome.trim() } : {}),
			quantita: Number(r.quantita.trim()),
			potenzaKw: r.potenzaKw.trim() === '' ? null : Number(r.potenzaKw.trim().replace(',', '.')),
		}));
}
